import React from 'react';
/** Return a hook that return a memoized map indexed by idKey of the input array (if defined)
 * T extends { [IdKey]: IdValue }[] -> Record<IdKey, T>
 */
function createUseArrayToMap(idKey) {
    function useArrayToMap(items) {
        return React.useMemo(() => items?.reduce((acc, x) => {
            const id = x[idKey];
            acc[id] = x;
            return acc;
        }, {}), [items]);
    }
    return useArrayToMap;
}
export const useIdMap = createUseArrayToMap('id');
export const useProductIdMap = createUseArrayToMap('productId');
